import {
  Box,
  CircularProgress,
  Typography,
} from '@mui/material';
import cx from 'classnames';
import React, { useEffect, useState } from 'react';

const SIZE_STYLE_MAP = {
  small: { height: '30px', width: '30px' },
  large: { height: '60px', width: '60px' },
};

type LoaderProps = {
  isLoading: boolean;
  size?: 'small' | 'large';
  position?: 'fullScreen' | 'absolute' | 'static' | 'verticalFlow';
  transparent?: boolean;
  noBackground?: boolean;
  noThrottle?: boolean;
  label?: string;
}

const Loader = ({
  isLoading,
  size,
  position,
  transparent,
  noBackground,
  noThrottle,
  label,
}: LoaderProps) => {
  const [shouldRender, setShouldRender] = useState(noThrottle);

  useEffect(() => {
    if (!noThrottle) {
      const timeoutId = setTimeout(() => {
        setShouldRender(isLoading);
      }, 300);
      return () => clearTimeout(timeoutId);
    }
  }, [isLoading]);

  const loaderClasses = cx('loader', {
    loader_transparent: transparent,
    loader_fullScreen: position === 'fullScreen',
    loader_absolute: position === 'absolute',
    loader_static: position === 'static',
    loader_verticalFlow: position === 'verticalFlow',
    loader_noBackground: noBackground,
  });

  const loaderProgressClasses = cx('loader-progress', {
    'loader-progress_static': position === 'static',
  });

  if (shouldRender) {
    return (
      <div className={loaderClasses}>
        {label && <Box marginRight={1}><Typography variant='body2'>{label}</Typography></Box>}
        <CircularProgress className={loaderProgressClasses} style={SIZE_STYLE_MAP[size]} />
      </div>
    );
  }
};

export default Loader;
